@let isPositive = pipeProvided();

<svg-icon [src]="isPositive ? 'icons/icon-info-positive.svg' : 'icons/icon-info-negative.svg'"
          [name]="isPositive ? 'icon-info-positive' : 'icon-info-negative'"
          class="flex original-icon shrink-0"
          svgClass="!size-[1.25rem]"></svg-icon>
